import { render } from "./sim-sessions-data.vue?vue&type=template&id=4d4973ba&scoped=true"
import script from "./sim-sessions-data.vue?vue&type=script&lang=js"
export * from "./sim-sessions-data.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4d4973ba"

export default script